import { Box } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

interface propsType {
  searchList: any;
}

const SearchRunway = (props: propsType) => {
  const {season, designer} = useParams();
  const navigate = useNavigate();
  // const [searchList, setSearchList] = useState<any>(sample);
  const searchList = props.searchList;

  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const prevRef = useRef<HTMLDivElement>(null);
  const nextRef = useRef<HTMLDivElement>(null);
  const [isAtStart, setIsAtStart] = useState(true); // 슬라이드가 처음에 있는지
  const [isAtEnd, setIsAtEnd] = useState(false); // 슬라이드가 끝에 있는지
  const [swiperInstance, setSwiperInstance] = useState<any>(null); // Swiper 인스턴스를 저장

  const handleSlideChange = (swiper: any) => {
    setIsAtStart(swiper.isBeginning); // 슬라이드가 첫 번째면 true
    setIsAtEnd(swiper.isEnd); // 슬라이드가 마지막이면 true
  };

  const goRunway = (key: string) => {
    const lastList: any = [];
    const [targetSeason, targetDesigner] = key.split('#');

    for (const runway of searchList) {
      if (runway.season === targetSeason && runway.designer === targetDesigner) {
        // if (!lastList.includes(runway.mainimg)) {
        //   if (runway.mainimg) lastList.push(runway.mainimg);
        // }
        if (runway.imglist) lastList.push(...runway.imglist);
      }
    }

    window.localStorage.setItem("selectedImgList", lastList);

    const encodedSeason = encodeURIComponent(targetSeason);
    navigate(`/runway/${encodedSeason}/${targetDesigner}`);
  }

  return (
    <>
    <Box sx={{ mt: 4 }}>
      <div className="brief-cont">
        {searchList.length > 0 && (
          <div className="rel-brief" style={{ padding: "0px", margin: "0px", width: "100%", maxWidth: "100%" }}>
            <dl style={{ borderTop: "0px", paddingTop: '20px' }}>
              <dt>
                {designer} 다른 시즌 보기
                {/* <img src="/images/icon-look.png" alt="" /> */}
                <div style={{ width: "24px" }} />
                {/* 커스텀 화살표 */}
                <div className="swiper-navigation">
                  <div ref={prevRef} className="custom-prev-arrow">
                    <img
                      src="/images/icon-arr-prev-dark.png"
                      alt=""
                      style={{
                        opacity: isAtStart ? 0.2 : 1,
                        cursor: "pointer",
                        pointerEvents: swiperInstance ? "auto" : "none",
                      }}
                    />
                  </div>
                  <div ref={nextRef} className="custom-next-arrow">
                    <img
                      src="/images/icon-arr-next-dark.png"
                      alt=""
                      style={{
                        opacity: isAtEnd ? 0.2 : 1,
                        cursor: "pointer",
                        pointerEvents: swiperInstance ? "auto" : "none",
                      }}
                    />
                  </div>
                </div>
              </dt>
              <dd style={{ flexWrap: "nowrap" }}>
                <Swiper
                  slidesPerView={"auto"}
                  spaceBetween={25.8}
                  navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                  }}
                  modules={[Navigation]}
                  onSwiper={(swiper: any) => {
                    setSwiperInstance(swiper);
                    if (swiper.params.navigation) {
                      const navigation = swiper.params.navigation as any;
                      navigation.prevEl = prevRef.current;
                      navigation.nextEl = nextRef.current;
                      // swiper.navigation.init();
                      swiper.navigation.update();
                    }
                  }}
                  style={{ zIndex: 0, width: "100%" }}
                  onSlideChange={handleSlideChange} // 슬라이드 변경 시 상태 업데이트
                  onReachEnd={() => setIsAtEnd(true)}
                  onReachBeginning={() => setIsAtStart(true)}
                >
                  {searchList.map((info: any, index: number) => (
                    <SwiperSlide
                      key={`alike-list-${index}`}
                      style={{ width: "200px", borderRadius: "0px", height: "100%", alignItems: "start", display: "block" }}
                    >
                      <div
                        key={`alike-list-${index}`}
                        className="brief-box simple"
                        onClick={() => {
                          window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                          });
                          goRunway(`${info.season}#${info.designer}`);
                          // navigate(`/runway/${info.season}/${info.designer}`);
                        }}
                        style={{ width: "100%" }}
                      >
                        <div 
                          className="thumb-img" 
                          style={{ height: "260px", backgroundColor: "#fff" }} 
                          onMouseEnter={() => setHoveredIndex(index)}
                          onMouseLeave={() => setHoveredIndex(null)}
                        >
                          {info.mainimg &&  (
                            <img
                              src={info.mainimg}
                              alt=""
                              onError={(e) => {
                                e.currentTarget.src = "/images/no-image.png";
                                e.currentTarget.className = "noImage";
                              }}
                            />
                          )}
                        </div>
                        <div className="brief-summary">
                          <dl style={{ alignItems: 'center' }}>
                            <dt>
                              <p>{info.name}</p>
                            </dt>
                          </dl>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                  {/* 왼쪽 그라데이션: 처음 슬라이드가 아니면 표시 */}
                  {!isAtStart && <div className="swiper-gradient-left"></div>}

                  {/* 오른쪽 그라데이션: 마지막 슬라이드가 아니면 표시 */}
                  {!isAtEnd && <div className="swiper-gradient-right"></div>}
                </Swiper>
              </dd>
            </dl>
          </div>
        )}
      </div>
    </Box>
    <div style={{ height: "100px", width: "100%" }}></div>
    </>
  )
}

export default SearchRunway;